import { Accordion, AccordionTab } from 'primereact/accordion';
import { RadioButton } from 'primereact/radiobutton';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { arrayToDateString } from '../../../../../../../core/utils/DateMixins';
import TableApuracao from '../tableApuracao/TableApuracao';
import styles from './CollapseMeta.module.scss';

const Header = ({
    onChange,
    value,
    setValue,
    id,
    descMeta,
    numMeta,
    periodicidadeMeta,
    unidadeMedidaMeta,
    dataPrevisaoApuracao,
    hasChildren = false,
}) => {
    const Col = ({ title, value }) => (
        <div>
            <div>{title}</div>
            <div>{value}</div>
        </div>
    );

    return (
        <div className={`${styles.header}`}>
            {!hasChildren && (
                <span>
                    <RadioButton
                        name="input"
                        value={id}
                        onChange={(ev) => {
                            setValue(ev.value);
                            onChange(ev.value);
                        }}
                        checked={`${value}` === `${id}`}
                    />
                </span>
            )}
            <Col title="Meta N°" value={numMeta} />
            <Col title="Previsão de Apuração" value={arrayToDateString(dataPrevisaoApuracao)} />
            <Col title="Periodicidade" value={periodicidadeMeta?.siglaPeriodicidade} />
            <Col title="Unidade de Medida" value={unidadeMedidaMeta?.descUnidadeMedida} />
            <Col title="Valor da Meta" value={descMeta} />
        </div>
    );
};

function CollapseMeta({ onChange, onSave, disableActions = false, children, ...meta }, ref) {
    const [value, setValue] = useState('');
    const [activeIndex, setActiveIndex] = useState(null);

    useImperativeHandle(
        ref,
        () => ({
            value,
            setValue,
            meta,
        }),
        [value, meta]
    );

    return (
        <Accordion
            activeIndex={activeIndex}
            onTabChange={(e) => {
                if (!`${e.originalEvent.target.className}`.includes('p-radiobutton')) {
                    setActiveIndex(e.index);
                }
            }}
            className="p-col-12"
            collapseIcon="pi pi-angle-double-down"
            expandIcon="pi pi-angle-double-left"
        >
            <AccordionTab
                className={`${styles.accordion} ${children ? styles.hasChildren : ''}`}
                header={
                    <Header
                        hasChildren={children ? true : false}
                        value={value}
                        onChange={onChange}
                        setValue={setValue}
                        {...meta}
                    />
                }
            >
                <TableApuracao
                    onSave={onSave}
                    disableActions={disableActions}
                    metaId={meta?.id}
                    apuracao={meta?.apuracaoMeta}
                />
                {children}
            </AccordionTab>
        </Accordion>
    );
}

export default forwardRef(CollapseMeta);
